import { mode } from '@chakra-ui/theme-tools';
var parts = ['item', 'list', 'value', 'scroll', 'icon'];

function baseStyleList(props) {
  return {
    bg: mode('#fff', 'gray.800')(props),
    borderColor: 'white',
    borderRadius: 'md',
    borderWidth: '1px',
    boxShadow: mode('sm', 'dark-lg')(props),
    maxH: '18.75em',
    width: {
      base: 'xs',
      md: '6.125rem'
    },
    overflowY: 'auto',
    position: 'relative',
    px: 0,
    py: 0,
    zIndex: 'timePicker',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      width: {
        base: 'xs',
        md: '6.125rem'
      },
      bg: {
        base: 'linear-gradient(to bottom, white, rgba(255, 255, 255, 0))',
        md: 'transparent'
      },
      height: 4
    },
    '&::after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      width: {
        base: 'xs',
        md: '6.125rem'
      },
      height: 4,
      bg: {
        base: 'linear-gradient(to top, white, rgba(255, 255, 255, 0))',
        md: 'transparent'
      }
    }
  };
}

var baseStyleScroll = {
  overflowY: 'scroll',
  textAlign: 'center',
  color: 'inherit',
  maxH: '18em',
  borderBottom: 'inset .5rem white',
  width: {
    base: 'xs',
    md: '6.125rem'
  },
  paddingTop: {
    base: '4',
    md: '2'
  },
  paddingBottom: 0
};

function baseStyleItem(props) {
  return {
    py: '0.4rem',
    px: '0.8rem',
    textDecoration: 'none',
    color: 'inherit',
    userSelect: 'none',
    display: 'flex',
    width: '100%',
    justifyContent: 'center',
    textAlign: 'center',
    flex: '0 0 auto',
    outline: 0,
    borderRadius: {
      base: '5px',
      md: '0'
    },
    transition: 'background 50ms ease-in 0s',
    bg: mode('white', 'whiteAlpha.100')(props),
    '&:hover:enabled, &:focus:enabled': {
      bg: mode('brand.500', 'whiteAlpha.100')(props),
      color: 'white',
      fontWeight: 700
    },
    '&:disabled': {
      opacity: 0.4,
      cursor: 'not-allowed'
    }
  };
}

function baseStyleInputGroup(props) {
  return {
    alignItems: 'center',
    bg: 'white',
    borderBottom: '1px solid',
    borderColor: mode('gray.700', 'gray.300')(props),
    color: 'black',
    display: 'inline-flex',
    justifyContent: 'space-between',
    outline: 0,
    py: 2,
    textAlign: 'left',
    textDecoration: 'none',
    transition: 'all 250ms',
    _invalid: {
      borderColor: mode('red.500', 'red.200')(props)
    },
    _expanded: {
      borderColor: mode('brand.500', 'brand.200')(props)
    },
    '&:focus, &:active ': {
      borderColor: mode('brand.500', 'brand.200')(props)
    },
    _disabled: {
      opacity: 0.4,
      cursor: 'not-allowed'
    }
  };
}

var baseStyleInput = {
  textDecoration: 'none',
  color: 'black',
  outline: 0,
  bg: 'transparent',
  width: '100%',
  textAlign: 'left',
  // maxWidth: { base: '100%', md: '6rem' },
  '&::placeholder': {
    color: 'black'
  }
};

var baseStyle = props => ({
  list: baseStyleList(props),
  item: baseStyleItem(props),
  scroll: baseStyleScroll,
  inputGroup: baseStyleInputGroup(props),
  input: baseStyleInput
});

export default {
  parts,
  baseStyle
};
//# sourceMappingURL=TimePicker.js.map